import React, { useRef, useEffect, useState } from 'react';
import * as R from 'ramda';
import $ from 'jquery';
import {FrenchTypes} from '../../../../../../constants/utils/connectionTypes';
import ServiceData from '../../../../../../constants/models/serviceData';
import AddressInfo from '../../../../../../constants/models/addressInfo';

import {ModalOtherActivitySection} from './otherActivitySection';

export const ModalOtherActivity = ({activities, isLoading, userId}) => {
    const [activityList, setActivityList] = useState([...activities]);
    useEffect(() => {
        setActivityList([...activities]);
    }, [activities]);

    function removeFromList(index){
        setActivityList(activityList.filter(a => a !== activityList[index]));
    }
    return (
        <div className="modal fade px-0" id="otherActivityModal" aria-labelledby="otherActivityModalLabel" aria-hidden="true">
            <div className="modal-dialog px-2 container-screen">
                <div className="modal-content">
                    <div className="modal-header" data-dismiss="modal" aria-label="Close">
                        <div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
                            <h1 className="sr-only visually-hidden">Information deceased</h1>
                            <div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1" id="activityModalLabel">Autre activité</div>
                        </div>
                    </div>
                    <div className="modal-body scroll-default py-0">
                        {/* <p className="o-60">Modifier les champs qui ne sont pas mis à jour</p> */}

                        <article className="card" id="activity">
                            <h3 className="sr-only visually-hidden">En activité</h3>
                            
                            {
                                activityList.map((activity, index) => {
                                    return (<ModalOtherActivitySection activity={activity} initCollapsedState={false} index={index} isLoading={isLoading} key={index} removeFromList={removeFromList} />)
                                })
                            }
                            <footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center pt-4 pb-1">
                                <h4 className="sr-only visually-hidden">Ajouter une autre ACTIVITÉ</h4>
                                <button type="button" className="btn btn-icon btn-alert-info mx-auto py-2" onClick={(e) => {
                                    let serviceData = new ServiceData({ userId: userId, serviceType: FrenchTypes.otherActivity, serviceId: FrenchTypes.otherActivity+activityList.length, payload: {
                                        type: FrenchTypes.otherActivity,
                                        name: "",
                                        address: new AddressInfo({addressCountry:'FR', streetAddress: "",streetAddress2: "",postalCode: "", addressLocality: ""}),
                                        function: "",
                                    } });
                                    setActivityList([...activityList, {...serviceData, collapsed: true}]);
                                }}>
                                    <i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter une autre ACTIVITÉ
                                </button>
                            </footer>
                        </article>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-light mr-2" data-dismiss="modal" onClick={
                            (e) => {
                                e.preventDefault();
                                setActivityList([...activities]);
                            }
                        }>Fermer</button>
                        {/* <button type="button" className="btn btn-info" onClick={(e) => {
                            e.preventDefault();
                            //activityForm.current.classList.add('was-validated');
                            //setWasValidated(true);
                        }}>Sauvegarder</button> */}
                    </div>
                </div>
            </div>
        </div>
    )
}